import React from 'react';
import "./Index.css";
import { FaLongArrowAltRight } from "react-icons/fa";

export const Trading = () => {
    return <div className='row m-0 d-flex justify-content-center'>
        <div className='trading-bg col-md-9 col-10 d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap p-5'>
            <div>
                <h2 className='text-white text-center text-md-start'>Dive right in with a secure, low-cost, <br/>and easy-to-use trading platform</h2>
                <p className='text-white text-center text-md-start'>Our community trust us, and so can you. </p>
            </div>
            <button className='trade-button'>
                <small>Start trading in less<br/>than a minute</small>
                <FaLongArrowAltRight color='white'/>
            </button>
        </div>

    </div>
}